import React, { memo, Fragment, useState } from 'react'
import { SecondaryButton } from 'root/src/client/web/base/CustomButton'
import { ternary } from 'root/src/shared/util/ramdaPlus'
import goToDeliveryFormHandler from 'root/src/client/logic/project/handlers/goToDeliveryFormHandler'
import goToSignInHandler from 'root/src/client/logic/project/handlers/goToSignInHandler'
import ButtonWithSubtitle from 'root/src/client/web/base/CustomButton/ButtonWithSubtitle'
import map from 'ramda/src/map'
import pick from 'ramda/src/pick'
import {
	notConnected, connectedNotClaimed, accepted, notEligible, videoPending, pending,
} from 'root/src/shared/constants/projectAcceptanceStatuses'
import goToClaimProjectHandler from 'root/src/client/logic/project/handlers/goToClaimProjectHandler'
import LoadingSpinner from 'root/src/client/web/base/LoadingSpinner'
import { DELIVERY_DARE_FORM_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import ButtonNew from 'root/src/client/web/base/ButtonNew'

const ClaimButton = memo(({
	projectAcceptanceStatus,
	assignees,
	projectUrl,
	isAuthenticated,
	buttonTextWrapperClass,
	buttonWrapperClass,
	oauthAuthenticate,
	icon,
	brandProduct,
	claimSponsoredProject,
	setInput,
	projectDeliveries,
	redirectAndPrePopulate,
	isSubmittable,
}) => {
	const [loading, setLoading] = useState(false)
	switch (projectAcceptanceStatus || undefined) {
	case (notConnected):
		return (
			<Fragment>
				<div className={buttonTextWrapperClass}>
					Connect with Twitch
				</div>
				<div className={buttonWrapperClass}>
					<SecondaryButton
						title="Accept or reject Dare"
						subtitle="Connect with Twitch"
						icon={icon}
						onClick={
							ternary(isAuthenticated,
								//
								e => oauthAuthenticate('twitch', {
									assignees: map(pick(['platformId', 'platform']), assignees),
									projectUrl,
								})(e, () => {
									// TODO change to true and fix \/\/
									setLoading(false)
								}),
								goToSignInHandler)
						}
					>
						<LoadingSpinner loading={loading} />
					</SecondaryButton>
				</div>
			</Fragment>
		)
	case (connectedNotClaimed):
		return (
			<ButtonNew
				htmlType="button"
				disabled={loading}
				onClick={
					ternary(brandProduct,
						async () => {
							setLoading(true)
							await claimSponsoredProject(projectUrl)
							setLoading(false)
						},
						() => goToClaimProjectHandler(projectUrl))
				}
			>
				<LoadingSpinner loading={loading} />
				{brandProduct ? 'Accept' : 'Set Goal'}
			</ButtonNew>
		)
	case (accepted && isSubmittable):
		return (
			<Fragment>
				<div className={buttonTextWrapperClass}>
					Upload to complete the Dare
				</div>
				<div className={buttonWrapperClass}>
					<ButtonWithSubtitle
						title="Deliver Dare Video"
						onClick={() => goToDeliveryFormHandler(projectUrl)}
					/>
				</div>
			</Fragment>
		)
	case (videoPending):
		return (
			<Fragment>
				<div className={buttonTextWrapperClass}>
					Change Dare Video
				</div>
				<div className={buttonWrapperClass}>
					<ButtonWithSubtitle
						title="Change"
						onClick={() => redirectAndPrePopulate({
							prePopulateData: { videoURL: projectDeliveries.videoURL },
							redirectRouteId: DELIVERY_DARE_FORM_ROUTE_ID,
							setInput,
							recordId: projectUrl,
						})}
					/>
				</div>
			</Fragment>
		)
	case pending:
		return (
			<div style={{ marginTop: 20 }}>
				<strong>Waiting for admin approve</strong>
			</div>
		)
	case (notEligible):
		return null
	default:
		return null
	}
})

export default ClaimButton
